import {
  createChainOfResponsibility
} from "./chunk-QOVF7TZ6.mjs";
export {
  createChainOfResponsibility
};
//# sourceMappingURL=react-chain-of-responsibility.mjs.map